<template>
  <ul v-if="hasContent" class="bullet-text">
    <li v-for="(line, idx) in lines" :key="idx" class="wd-whitespace-pre-line" :class="{ 'wd-mt-1': idx > 0 }">
      {{ line }}
    </li>
  </ul>
</template>

<script setup lang="ts">
defineOptions({ name: 'BulletText' })

interface Props {
  content?: string | string[] | null
}

const props = withDefaults(defineProps<Props>(), {
  content: '',
})

const lines = computed<string[]>(() => {
  const raw = props.content ?? ''
  const list = Array.isArray(raw) ? raw : raw.split('\n')

  return list.map(item => `${item ?? ''}`.trim()).filter(text => text !== '')
})
const hasContent = computed(() => lines.value.length > 0)
</script>
